import { all, put, call, takeLatest, select, takeEvery } from 'redux-saga/effects';
import {
  showLoading,
  hideLoading,
  showPullToRefresh,
  hidePullToRefresh
} from '../../actions/Login/action';
import {
  getSearchParams,
  getPullToRefreshState,
  getWebNotificationsData,
  getSearchRefDeepLink
} from '../../selectors/selector';
import { getFavorite } from '../../actions/Favorite/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import {
  GetRecent,
  fetchUserDetailsSuccess,
  moreTabContentResponse,
  clearRegisterUserStatusMessage,
  getConfigParams,
  moreTabContentResponseDummy,
  updateSearchParamsInOfflineJSON,
  updateShipmentInfoInOfflineJSON,
  registerDeviceResponseAction,
  registerUserStatusMessage,
  getSearchedLoadById,
  saveUserPreferences,
  homeWebContentResponse,
  setWebNotifications,
  setDynamicLinkParams,
  saveUserPreferencesDomain,
  fetchNewUserDetailsSuccess,
} from '../../actions/App/action';
import { DomainConverter, IONICWrapper, isMobile } from '../../utils/common';
import {
  loadCarrierData,
  loadAssignedData,
  inTransitData,
} from '../../actions/carrierAssign/action';
import { getMyloadData } from '../../utils/mock_Data';
import { GetMyLoadCardData } from '../../actions/myload/action';
import { loadSearchData } from '../../actions/Search/action';
import { DEEPLINK_ERR_EXPIRED } from '../../utils/constants';
import { ToastMessage } from '../../utils/ToastMessage';
import { ICONTENT_OR_CONFIG_RESPONSE } from '../../utils/AllInterface';
import { FetchPreferences } from '../../models/Preferences/FetchPreferences.model';
import { UpdatePreferences } from '../../models/Preferences/UpdatePreferences.model';
import { PreferenceConvertor } from '../../utils/PreferenceConvertor';

const APPLICATION_JSON = 'application/json';
export function* updateGpsData(data: any) {
  try {
    yield put(showLoading());
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function checkTimeInterval(date: string, interval: string): boolean {
  return false;
}

export function* fetchRecentResults(action: any) : any {
  const { data, isHideLoader } = action && action.payload && action.payload;
  const searchParamsSelector = getSearchParams();
  const searchParamsState = yield select(searchParamsSelector);
  const pullToRefreshSelector = getPullToRefreshState();
  const pullToRefreshState = yield select(pullToRefreshSelector);
  if (
    searchParamsState &&
    checkTimeInterval(
      searchParamsState.RecentSearch,
      searchParamsState.RecentSearchInterval
    ) &&
    !pullToRefreshState
  ) {
    return;
  }
  try {
    if (!(action && action.payload && isHideLoader)) yield put(showLoading());
    yield put(showPullToRefresh());
    const recentReqestQuery = DomainConverter.domainToData<any>(data);
    const fetchRecentResults = yield request<any>([
      'RECENT',
      'RECENT',
      null,
      '',
      recentReqestQuery,
      APPLICATION_JSON
    ]);
    yield put(GetRecent(fetchRecentResults));
    yield put(
      updateSearchParamsInOfflineJSON({
        RecentSearch: new Date().toUTCString(),
        RecentSearchInterval: '5'
      })
    );
    if (!(action && action.payload && isHideLoader)) yield put(hideLoading());
    yield put(hidePullToRefresh());
  } catch (e) {
    if (!(action && action.payload && isHideLoader)) yield put(hideLoading());
    yield put(hidePullToRefresh());
  }
}

// handle API call to fetch favorite search data list
export function* fetchFavoriteData(action: any) :any{
  const { isHideLoader } = action && action.payload && action.payload;
  const searchParamsSelector = getSearchParams();
  const searchParamsState = yield select(searchParamsSelector);
  const pullToRefreshSelector = getPullToRefreshState();
  const pullToRefreshState = yield select(pullToRefreshSelector);
  if (
    searchParamsState &&
    checkTimeInterval(
      searchParamsState.FavouriteSearch,
      searchParamsState.FavouriteSearchInterval
    ) &&
    !pullToRefreshState
  ) {
    return;
  }
  try {
    if (!(action && action.payload && isHideLoader)) {
      yield put(showLoading());
    }
    yield put(showPullToRefresh());
    const favoriteRequestQuery = DomainConverter.domainToData<any>(
      action.payload.data
    );
    const fetchFavoriteResults = yield request<any>([
      'FAVORITE',
      'FAVORITE_LOADS',
      null,
      '',
      favoriteRequestQuery,
      APPLICATION_JSON
    ]);
    yield put(getFavorite(fetchFavoriteResults));
    yield put(
      updateSearchParamsInOfflineJSON({
        FavouriteSearch: new Date().toUTCString(),
        FavouriteSearchInterval: '5'
      })
    );
    if (!(action && action.payload && isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
  } catch (e) {
    if (!(action && action.payload && isHideLoader)) yield put(hideLoading());
    yield put(hidePullToRefresh());
  }
}

export function* fetchUserDetailsSaga(data: any) :any {
  try {
    const { token, body } = data.payload;
    const queryPayloads = DomainConverter.domainToData<any>(body);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'GET_USER_DETAILS',
      null,
      token,
      queryPayloads,
      APPLICATION_JSON
    ]);
    const userDetails =
      response.data &&
      response.data.getUserDetails &&
      response.data.getUserDetails.length > 0 &&
      response.data.getUserDetails[0];
    if (!userDetails) {
      yield put(fetchUserDetailsSuccess({}));
    } else {
      yield put(fetchUserDetailsSuccess(userDetails));
    }
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* fetchUserDetailsNewSaga(data: any) :any {
  try {
    const { token, query } = data.payload;
    if(data && data.payload && data.payload.isPullToRefresh === false)
    {
    yield put(showPullToRefresh());
    }
    const queryPayloads = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS_NEW',
      'GET_USER_DETAILS_NEW',
      null,
      token,
      queryPayloads,
      APPLICATION_JSON
    ]);
    if(data && data.payload && data.payload.isPullToRefresh === false)
    {
    yield put(hidePullToRefresh());
    }
    const userDetailsNew =
      response.data &&
      response.data.getUserDetails
      if (!userDetailsNew) {
        yield put(fetchNewUserDetailsSuccess({}));
      } else {
        yield put(fetchNewUserDetailsSuccess(userDetailsNew));
        yield put(hideLoading());
      }
      if (userDetailsNew && userDetailsNew.userPreference) {
        const pref = userDetailsNew &&
          userDetailsNew.userPreference &&
           userDetailsNew.userPreference[0] &&
          userDetailsNew.userPreference[0].preferences
        const domain: string = userDetailsNew &&
          userDetailsNew.userPreference &&
          userDetailsNew.userPreference[0] &&
         userDetailsNew.userPreference[0].domain
        yield put(saveUserPreferences(PreferenceConvertor(pref)));
        yield put(saveUserPreferencesDomain(domain));
      } 
      else {
        userDetailsNew && userDetailsNew.error.length > 0 && userDetailsNew.error.map((error: any) => {
          console.error("Preferences fetching error",error.message );
          (isMobile) ? ToastMessage.show(error.message || constants.GENERIC_FAILURE_MESSAGE) : ToastMessage.showWeb(error.message || constants.GENERIC_FAILURE_MESSAGE)
        }
        )
        yield put(saveUserPreferences(constants.PREFERENCE_API_FALLBACK.userPreferences));
        yield put(saveUserPreferencesDomain(constants.PREFERENCE_API_FALLBACK.userPreferencesDomain));
      }
  } catch (e) {
    console.error(e)
    if(data && data.payload && data.payload.isPullToRefresh === false)
    {
    yield put(hidePullToRefresh());
    }
    yield put(hideLoading());
  }
}

export function* registerDeviceSaga(data: any) :any{
  try {
    const registerDivceQuery = DomainConverter.domainToData<any>(data.payload);
    const deviceRegisterResult = yield call(request, [
      'REGISTER_DEVICE',
      'REGISTER_DEVICE',
      null,
      '',
      registerDivceQuery,
      APPLICATION_JSON
    ]);
    yield put(
      registerDeviceResponseAction({
        deviceRegisterResult: deviceRegisterResult.data,
        errors: deviceRegisterResult.errors
      })
    );
  } catch (error) {
     yield put(
      registerDeviceResponseAction({
        deviceRegisterResult: null,
        errors: [error.message]
      })
    );
  }
}

export function* fetchDriverrAssignedLoadsFromPush(data: any) :any{
  try {
    const filter = data.payload.query.query.getShipmentsWithStopsByState.__args.filter;

    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(showLoading());
    }
    const getShipmentQuery = DomainConverter.domainToData<any>(
      data.payload.query
    );
    const fetchResults = yield call(request, [
      'MYLOAD',
      'CARRIER',
      null,
      '',
      getShipmentQuery,
      APPLICATION_JSON
    ]);
    const result = fetchResults.data.getShipmentsWithStopsByState;

    if (filter.driverAssigned) {
      yield put(
        loadAssignedData(
          result.driverAssignedShipments,
          result.driverAssignedCount
        )
      );
    }

    if (filter.carrierAssigned) {
      yield put(
        loadCarrierData(
          result.carrierAssginedShipments,
          result.carrierAssignedCount
        )
      );
    }

    if (filter.inTransit) {
      yield put(
        inTransitData(result.inTransitShipments, result.inTransitCount)
      );
    }

    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(hideLoading());
    }

    if (data && data.payload && data.payload.callback) {
      data.payload.callback();
    }
  } catch (e) {
    if (!(data && data.payload && data.payload.isHideLoader)) {
      yield put(hideLoading());
    }
  }
}

export function* fetchMoreTabContent(data: any) :any{
  try {
    yield put(showLoading());
    const moreTabContentQuery = DomainConverter.domainToData<any>(data.payload);

    const fetchResults = yield call(request, [
      'MORETAB',
      'MORETAB',
      null,
      '',
      moreTabContentQuery,
      APPLICATION_JSON
    ]);
    if (fetchResults.data.getUserHelpContent) {
      yield put(moreTabContentResponse(fetchResults));
    } else {
      yield put(homeWebContentResponse(fetchResults));
    }
    yield put(hideLoading());
    yield put(
      moreTabContentResponseDummy({
        termsAndConditions: '1.0',
        eula: '0.0',
        privacy: '1.0',
        contactOptions: '0.0',
        videoWalkthroughs: '1.0',
        aboutSchneider: '2.0',
        becomingCarrier: '1.0',
        faq: '0.0',
        schneiderOfferings: '0.0'
      })
    );
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* MyLoadCardDataData() {
  try {
    yield put(showLoading());
    const repos = getMyloadData();
    yield put(GetMyLoadCardData(repos));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* fetchConfigJSON(action: any) {
  try {
    yield put(showLoading());

    yield put(getConfigParams(constants.configParamsConstant));
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}
export function* Registeruser(data: any) :any{
  try {
    clearRegisterUserStatusMessage();
    yield put(showLoading());
    const { token, body } = data.payload;
    const registerQuery = DomainConverter.domainToData<any>(body);
    const fetchResults = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      token,
      registerQuery,
      APPLICATION_JSON
    ]);
    const regiserUser =
      (fetchResults &&
        fetchResults.data &&
        fetchResults.data.registerMember) ||
      {};

    const errors = fetchResults && fetchResults.errors;
    if (!errors) {
      yield put(fetchUserDetailsSuccess({member:regiserUser.member}));
      yield put(
        registerUserStatusMessage({
          status: regiserUser.status,
          message: regiserUser.message,
          registerClicked: true
        })
      );
    } else if (errors && errors.length > 0 && errors[0].message) {
      yield put(
        registerUserStatusMessage({
          status: false,
          message: errors[0].message,
          registerClicked: true
        })
      );
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* findSearchDataAPI(action: any) {
  try {
    yield put(showLoading());
    yield put(
      updateSearchParamsInOfflineJSON({
        RecommendedLoads: true,
        RecommendedLoadsInterval: '5',
        WatchedLoads: true,
        WatchedLoadsInterval: '10',
        RecentSearch: true,
        RecentSearchInterval: '10',
        FavouriteSearch: true,
        FavouriteSearchInterval: '10'
      })
    );
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* findShipmentInfoAPI(action: any) {
  try {
    yield put(showLoading());
    yield put(
      updateShipmentInfoInOfflineJSON({
        shipment: true,
        shipmentInterval: '5'
      })
    );
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* UpdateUserPreferences(action: any): any {
  try {
    const { payload } = action;
    if (payload) {
      yield put(showLoading());
      const UpdatePreferencesModel: UpdatePreferences = new UpdatePreferences();
      const query = DomainConverter.domainToData<any>(UpdatePreferencesModel.updateUserPreference(payload));
      let preferenceResult: any = yield call(request, [
        'EXPERIENCE',
        'POST_PREFERENCE',
        null,
        '',
        query,
        APPLICATION_JSON,
      ]);
      if (getPreferenceResult(preferenceResult)) {
        displayToastMessage();
        const updatedprefList =
          preferenceResult &&
          preferenceResult.data &&
          preferenceResult.data.updateUserPreference &&
          preferenceResult.data.updateUserPreference.preferences;
        yield put(saveUserPreferences(PreferenceConvertor(updatedprefList)))
        yield put(hideLoading());
      } else {
        preferenceResult && preferenceResult.errors.length > 0 && preferenceResult.errors.map((error: any) =>
            (isMobile) ? ToastMessage.show(error.message || constants.GENERIC_FAILURE_MESSAGE) : ToastMessage.showWeb(error.message || constants.GENERIC_FAILURE_MESSAGE)
          )
      }
    }
    yield put(hideLoading());
  } catch (error) {
    error.length > 0 && error.map((error: any) =>
      console.error("updating preferences error : ", error.message)
    )
    yield put(hideLoading());
  }

}

function displayToastMessage() {
  (isMobile) ? ToastMessage.show(constants.PREFERENCE_API_FALLBACK.PreferenceUpdateSuccessMsg)
    : ToastMessage.showWeb(constants.PREFERENCE_API_FALLBACK.PreferenceUpdateSuccessMsg);
}

function getPreferenceResult(preferenceResult: any) {
  return preferenceResult && preferenceResult.data && preferenceResult.data.updateUserPreference;
}

export function* searchLoadDataById(action: any) :any{
  const { queryData, isHideLoader, callback } = action && action.payload && action.payload;
  try {
    if (!(action && action.payload && isHideLoader)) yield put(showLoading());
    const searchLoadByIdRequestQuery = DomainConverter.domainToData<any>(queryData);
    const fetchLoadsResults = yield request<any>([
      'SEARCH',
      'SEARCH',
      null,
      '',
      searchLoadByIdRequestQuery,
      APPLICATION_JSON
    ]);
    const DeepLinkNotValid = getDeeplinkNotValid();
    const shipments = getFetchLoadsResults(fetchLoadsResults);  
    const loadPostings = getLoadPostingsData(fetchLoadsResults); 
    const deepLinkURISelector = getSearchRefDeepLink();
    const deepLink = yield select(deepLinkURISelector);
    if (deeplinkShipmentValidation(deepLink, shipments)) { 
      if (isHider(action, isHideLoader)) yield put(hideLoading());
      isMobileShowToastMessageShow(DeepLinkNotValid);
      yield put(setDynamicLinkParams({paramsDict:null,deepLinkURI:null}));
      return; 
    }
    else if (deeplinkValidation(deepLink, loadPostings)) {
      if (isHider(action, isHideLoader)) yield put(hideLoading());
      isMobileShowToastMessageShow(DeepLinkNotValid);
      yield put(setDynamicLinkParams({paramsDict:null,deepLinkURI:null}));
      return;
    }
    yield put(getSearchedLoadById(fetchLoadsResults));
    if(loadPostings.length) { yield put(loadSearchData({ searchLoads: [...fetchLoadsResults.data.searchLoadByReferenceV2.loadPostings], totalRecords: 1 }, false)); }
    if (isHider(action, isHideLoader)) yield put(hideLoading());
    const searchedReferenceId = getSearchReferenceID(queryData);
    loadPostingCallBack(callback);
    showLoadpostingToadMessage(shipments, loadPostings, searchedReferenceId);
    yield put(setDynamicLinkParams({paramsDict:null,deepLinkURI:null}));
  } catch (e) {
    if (!(action && action.payload && isHideLoader)) yield put(hideLoading());
    yield put(setDynamicLinkParams({paramsDict:null,deepLinkURI:null}));
  }
}

const loadPostingCallBack = (callback:any) => callback && callback();

function showLoadpostingToadMessage(shipments: any, loadPostings: any, searchedReferenceId: any) {
  if (shipments.length === 0 && loadPostings.length === 0) { ToastMessage.show(`No results found for ${searchedReferenceId}`); }
}

function getSearchReferenceID(queryData: any) {
  return queryData.query && queryData.query.searchLoadByReferenceV2 && queryData.query.searchLoadByReferenceV2.__args && queryData.query.searchLoadByReferenceV2.__args.input && queryData.query.searchLoadByReferenceV2.__args.input.loadNumberAlias||"";
}

function isHider(action: any, isHideLoader: any) {
  return !(action && action.payload && isHideLoader);
}

function deeplinkShipmentValidation(deepLink: any, shipments: any) {
  return (deepLink && deepLink.includes("/app/search")) && shipments.length > 0;
}

function deeplinkValidation(deepLink: any, loadPostings: any) {
  return (deepLink && deepLink.includes("app/MyLoad")) && loadPostings.length > 0;
}

function isMobileShowToastMessageShow(DeepLinkNotValid: any) {
  (isMobile) ? ToastMessage.show(DeepLinkNotValid) : ToastMessage.showWeb(DeepLinkNotValid);
}

function getLoadPostingsData(fetchLoadsResults: any) {
  return fetchLoadsResults && fetchLoadsResults.data && fetchLoadsResults.data.searchLoadByReferenceV2 && fetchLoadsResults.data.searchLoadByReferenceV2.loadPostings || [];
}

function getFetchLoadsResults(fetchLoadsResults: any) {
  return fetchLoadsResults && fetchLoadsResults.data && fetchLoadsResults.data.searchLoadByReferenceV2 && fetchLoadsResults.data.searchLoadByReferenceV2.shipments || [];
}

function getDeeplinkNotValid() {
  return IONICWrapper.details.keys && IONICWrapper.details.keys.configuration && IONICWrapper.details.keys.configuration.deepLinkNotValid || DEEPLINK_ERR_EXPIRED;
}

export function* fetchUserNotifications(action: any) :any{
  try {
    const upn = action.payload;
    let notificationResponse = yield call(request, [
      'NOTIFICATION_SERVICES',
      'GET_NOTIFICATION',
      upn,
      '',
      null,
      APPLICATION_JSON
    ]);
    if (notificationResponse.length > 0) {
      let newNotificationsCount = 0;
      notificationResponse.map((item: any) => {
        if (item.notificationStatus === "NEW") {
          newNotificationsCount++;
        }
      })
      yield put(setWebNotifications({ notificationsData: notificationResponse, newNotificationsCount }));
    }
  } catch (error) {
    console.error("ERROR notificationAPI 553", action.payload);
  }
}

export function* updateStatusOfUserNotification(action: any) :any{
  const { vendorMessageID, notificationPayload } = action.payload;
  try {
    if (action.payload) {
      yield put(showLoading());
    }
    let notificationResponse = yield call(request, [
      'NOTIFICATION_SERVICES',
      'UPDATE_DELETE_NOTIFICATION',
      vendorMessageID,
      '',
      notificationPayload,
      APPLICATION_JSON
    ]);
    if (notificationResponse) {
      const notificationsDataSelector = getWebNotificationsData();
      const notificationsDataState = yield select(notificationsDataSelector);
      yield put(setWebNotifications({
        notificationsData: notificationsDataState.notificationsData.filter((item: any) =>
          item.vendorMessageID !== vendorMessageID),
        newNotificationsCount: notificationsDataState.newNotificationsCount
      }
      ));
      yield put(hideLoading());
    }
  } catch (error) {
    yield put(hideLoading());
    console.error("ERROR notificationAPI", action.payload);
  }
}

export function* updateNewToUnreadNotification(action: any) :any{
  try {
    if (action.payload) {
      yield put(showLoading());
    }
    let notificationResponse = yield call(request, [
      'NOTIFICATION_SERVICES',
      'UPDATE_NEW_TO_UNREAD_NOTIFICATION',
      '',
      '',
      action.payload,
      APPLICATION_JSON
    ]);
    if (notificationResponse) {
      const notificationsDataSelector = getWebNotificationsData();
      const notificationsDataState = yield select(notificationsDataSelector);
      yield put(setWebNotifications({
        notificationsData: notificationsDataState.notificationsData.map((item: any) => {
          if (item.notificationStatus === "NEW") {
            return { ...item, notificationStatus: "UNREAD" };
          }
          return item;
        }),
        newNotificationsCount: 0
      }
      ));
      yield put(hideLoading());
    }
  } catch (error) {
    yield put(hideLoading());
    console.error("ERROR notificationAPI 588", action.payload);
  }
}
export function* getTermsAndCondition() :any{
  try {
    const data:any = yield call(request, [
      "EXPERIENCE",
      'TERMS_AND_CONDITION',
      null,
      '',
      null,
      APPLICATION_JSON
    ]);
    Object.keys(data).forEach((e: any) => {
      const value = data[e];
      if (value !== null && value.length > 0) {
        value[0].output.forEach((item: any) => {
          if (item.name === constants.TERMS_CONDITIONS.MANAGED) {
            IONICWrapper.details.setKeyValuePairs = {
              [constants.TERMS_CONDITIONS.MANAGED]: item.content
            };
          }
          if (item.name === constants.TERMS_CONDITIONS.UNMANAGED) {
            IONICWrapper.details.setKeyValuePairs = {
              [constants.TERMS_CONDITIONS.UNMANAGED]: item.content
            };
          }
        });
      }
    });
  } catch (error) {
    if(error){
    console.error("ERROR Terms and condition : ", error.response && error.response.data);
    }
  }
}

export function* getUploadDocumentConfiguration(action: any):any {
  try {
    if (!IONICWrapper.details.getKeyValuePairs(constants.CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)) {
      yield put(showLoading());
      const data: any = yield call(request, [
        "EXPERIENCE",
        "CONTENTORCONFIG",
        null,
        "",
        action.payload || [],
        APPLICATION_JSON
      ]);
      data.forEach((singleResult: any) => {
        Object.keys(singleResult).forEach((e: any) => {
          const value: any = singleResult[e];
          if (value !== null && value.length > 0) {
            value.forEach(
              (item: ICONTENT_OR_CONFIG_RESPONSE) => {
                item.output.map((singleRow: any) => {
                  IONICWrapper.details.setKeyValuePairs = {
                    [singleRow.key]: JSON.parse(singleRow.value)
                  };
                });
              }
            );
          }
        });
      });
      yield put(hideLoading());
    }
  } catch (error) {
    yield put(hideLoading());
    if (error)
      console.error(
        "ERROR Upload document : ",
        error.response && error.response.data
      );
  }
}

export function* validateMobileNumberSaga(data: any) :any {
  try {
    const { param, callback } = data.payload;
    const queryPayloads = DomainConverter.domainToData<any>(param);
    const response = yield call(request, [
      'EXPERIENCE',
      'NUMBER_VALIDATION',
      null,
      '',
      queryPayloads || "",
      APPLICATION_JSON,
    ]);
    const mobileValidate = response.data && response.data.validatePhoneNumber;
    if (mobileValidate) {
      callback && callback({ type: "success", msg: "success" })
    } else {
      callback && callback({ type: "err", msg: "err" })
    }
  } catch (e) {
    yield put(hideLoading());
  }
}

export function* checkMobileNumberExistSaga(action: any): any {
  const { query, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    const details = response && response.data && response.data.validateUserByIdentifier || null;
    yield put(hideLoading());
      callback && callback(details ? "SUCCESS" : "FAILURE",details);
  } catch (e) {
    console.error("Error : ",e)
    yield put(hideLoading());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.UPDATE_GPS_COORDS, updateGpsData),
    takeLatest(constants.OFFLINE_MODE_START, fetchConfigJSON),
    takeLatest(constants.FIND_SEARCH_DATA, findSearchDataAPI),
    takeLatest(constants.FIND_SHIPMENT_INFO, findShipmentInfoAPI),
    takeLatest(constants.FETCH_USER_DETAILS, fetchUserDetailsSaga),
    takeLatest(constants.FETCH_USER_DETAILS_NEW, fetchUserDetailsNewSaga),
    takeLatest(constants.REGISTER_DEVICE_ACTION, registerDeviceSaga),
    takeLatest(
      constants.FETCH_DRIVER_ASSIGNED_LOADS_FROM_PUSH,
      fetchDriverrAssignedLoadsFromPush
    ),
    takeEvery(constants.GET_MORE_TAB_CONTENT, fetchMoreTabContent),
    takeLatest(constants.MYLOAD_CARD_DATA, MyLoadCardDataData),
    takeLatest(constants.RECENT_LOADS, fetchRecentResults),
    takeLatest(constants.REGISTER_USER, Registeruser),
    takeLatest(constants.FAVORITE_LOADS_DATA, fetchFavoriteData),
    takeLatest(constants.SEARCH_LOAD_BY_REFERENCE_ID, searchLoadDataById),
    takeLatest(constants.UPDATE_USER_PREFERENCES, UpdateUserPreferences),
    takeLatest(constants.GET_USER_NOTIFICATIONS, fetchUserNotifications),
    takeLatest(constants.UPDATE_STATUS_USER_NOTIFICATION, updateStatusOfUserNotification),
    takeLatest(constants.UPDATE_NEW_TO_UNREAD_NOTIFICATION, updateNewToUnreadNotification),
    takeLatest(constants.TERMS_CONDITION_REQUEST, getTermsAndCondition),
    takeLatest(constants.UPLOAD_DOCUMENT_CONFIG_TYPE, getUploadDocumentConfiguration),
    takeLatest(constants.VALIDATE_MOBILE_NUMBER, validateMobileNumberSaga),
    takeLatest(constants.REGISTER_CHECK_MOBILE_NUMBER_EXIST, checkMobileNumberExistSaga),
  ]);
}
